import React, { useState } from 'react';

import '../Assets/css/custom.css';
import '../Assets/css/w3-css.css';
import { Link } from 'react-router-dom';
import { Redirect } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import Header from '../Common/Header';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import FadeLoader from "react-spinners/HashLoader";
import Common from '../Common/CommonAPI';
import Common2 from '../Common/FD_BILL_APIs';
import "react-datepicker/dist/react-datepicker.css";
import FDWithdrawnDeposit from './FDWithdrawnDeposit';
import FDSummaryPDF from './FDSummaryPDF';
import FDLaons from './FDLoans';
import FDDetails from './FDDetails';

import FDwithdrawn from '../images/fdwithdrawn.png';
import FDwithdrawn2 from '../images/fdwithdrawno.png';
import DocImage from "../images/htransfer.png"
import FDLoanImage from "../images/fdloan.png"
import FDLoanImage2 from "../images/fdloano.png"
import requestFDLoanImage from "../images/requestFDloan.png"
import fdcal from "../images/fdcal.png"
import fdcal2 from "../images/fdcalo.png"
import fdrates from "../images/fdRates.png"
import fdrates2 from "../images/fdRateso.png"
import fdsmry from "../images/fdsmry.png"
import fdsmry2 from "../images/fdsmryo.png"
import createFD from "../images/createFD.png"
import uparrow from "../images/uparrow1.png"
import downarrow from "../images/downarrow1.png"
var api = require('../Common/Config');

class FDHome extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            FDList: [],
            Loading: true,
            totalDepositAmount: 0,
            TotalInterestSum: 0,
            paidInterest: 0,
            FDWithdraw: false,
            FDSummaryModal: false,
            FDLoansSection: false,
            CheckFDInfo: false,
            mouseOver1:0,
            fdSort:false,
            fdSort1:false,
            fdSort2:false,
            fdSort3:false,
            fdSort4:false,
            fdSort5:false,
        }
    }

    ResponseLoadingModal() {
        return (
            <Modal
                size="lg"
                centered
                className="ui-block" show={this.state.Loading}>
                <FadeLoader
                    height={25}
                    width={5}
                    radius={2}
                    margin={2}
                    color={"#197b55"}
                    size={"80px"} this also works
                    loading={this.state.Loading}
                />

            </Modal>
        )
    }

    componentDidMount() {
        this.GetFDAPI();
    }

    GetFDAPI = () => {
        Common2.FixedDeposits((result) => {
            this.setState({
                FDList: result.fdList.filter(e => e.status == "ACT" || e.status == "REN"),
                TotalAmount: result.totalDepositAmount,
                previousInterest: result.previousInterest,
                Loading: false,
            });
        })
    }

    async P_application() {
        const url = 'https://www.senfin.com/images/FD_Application(Individual,Joint).pdf';
        window.open(url, '_blank');
    }
    async C_application() {
        const url = 'https://www.senfin.com/images/FD_Application-Corporate.pdf';
        window.open(url, '_blank');
    }
    async Opencal() {
        const url = 'https://www.senfin.com/tools.html#FDCalculator';
        window.open(url, '_blank');
    }
    async fdRates() {
        const url = 'https://www.senfin.com/personal.html#FDTag';
        window.open(url, '_blank');
    }
    FDMoreInfo = (info) => {
        var FdInfor = {
            fdNumber: info.fdNumber,
        }
        var value = JSON.stringify(FdInfor);
        sessionStorage.setItem('fdValue', value);
        this.setState({ CheckFDInfo: true })
    }

    sortDep = () =>{    
        if(this.state.fdSort) {  
            this.state.FDList.sort(function (obj1, obj2) {
                // Ascending: first FD Num less than the previous
                var value1 = obj2.fdNumber - obj1.fdNumber;
                return value1;
            });
            this.forceUpdate(); 
        }
        if(this.state.fdSort===false) { 
                this.state.FDList.sort(function (obj1, obj2) {
                    // Ascending: first FD Num less than the previous
                    var value1 = obj1.fdNumber - obj2.fdNumber;
                    return value1;
                });
                this.forceUpdate();
        } 
    }
    sortDep1 = () =>{ 
        if(this.state.fdSort1){
            this.state.FDList.sort(function (obj1, obj2) {
                // Ascending: first FD Num less than the previous
                var value1 = obj2.depositAmount - obj1.depositAmount;
                return value1;
            });
            this.forceUpdate();
        }else{
            this.state.FDList.sort(function (obj1, obj2) {
                // Ascending: first FD Num less than the previous
                var value1 = obj1.depositAmount - obj2.depositAmount;
                return value1;
            });
            this.forceUpdate();
        }

        
    }
    sortDep2 = () =>{ 
        if(this.state.fdSort2){
            this.state.FDList.sort(function (obj1, obj2) {
                // Ascending: first FD Num less than the previous
                var value1 = obj2.totalInterestAmount - obj1.totalInterestAmount;
                return value1;
            });
            this.forceUpdate();
        }
        if(!this.state.fdSort2){
            this.state.FDList.sort(function (obj1, obj2) {
                // Ascending: first FD Num less than the previous
                var value1 = obj1.totalInterestAmount - obj2.totalInterestAmount;
                return value1;
            });
            this.forceUpdate();
        }       
    }
    sortDep3 = () =>{ 
        if(this.state.fdSort3){
            this.state.FDList.sort(function (obj1, obj2) {
                // Ascending: first FD Num less than the previous
                var value1 = obj2.totalInterestAmount - obj1.totalInterestAmount;
                return value1;
            });
            this.forceUpdate();
        }
        if(!this.state.fdSort3){
            this.state.FDList.sort(function (obj1, obj2) {
                // Ascending: first FD Num less than the previous
                var value1 = obj1.totalInterestAmount - obj2.totalInterestAmount;
                return value1;
            });
            this.forceUpdate();
        }
    }
    sortDep4 = () =>{ 
        if(this.state.fdSort4){
            this.state.FDList.sort(function (obj1, obj2) {
                // Ascending: first FD Num less than the previous
                var value1 = obj2.paidAmount - obj1.paidAmount;
                return value1;
            });
            this.forceUpdate();
        }
        if(!this.state.fdSort4){
            this.state.FDList.sort(function (obj1, obj2) {
                // Ascending: first FD Num less than the previous
                var value1 = obj1.paidAmount - obj2.paidAmount;
                return value1;
            });
            this.forceUpdate();
        }
    }
    sortDep5 = () =>{ 
        if(this.state.fdSort5){
            this.state.FDList.sort(function (obj1, obj2) {
                // Ascending: first FD Num less than the previous
                return new Date(moment(obj2.matirutyDate).format('DD/MM/YYYY').split('/').reverse()) - new Date(moment(obj1.matirutyDate).format('DD/MM/YYYY').split('/').reverse());
            });
            this.forceUpdate();
            this.forceUpdate();
        }
        if(!this.state.fdSort5){
            this.state.FDList.sort(function (obj1, obj2) {
                // Ascending: first FD Num less than the previous
                return new Date(moment(obj1.matirutyDate).format('DD/MM/YYYY').split('/').reverse()) - new Date(moment(obj2.matirutyDate).format('DD/MM/YYYY').split('/').reverse());
            });
            this.forceUpdate();
            this.forceUpdate();
        }
    }

render() {
    var arry = this.state.FDList.map((listValue, index) => { return (listValue.totalInterestAmount) })
    this.state.TotalInterestSum = arry.reduce((acc, val) => {
        return acc + val;
    }, 0)

    var arry1 = this.state.FDList.map((listValue, index) => { return (listValue.paidAmount) })
    this.state.paidInterest = arry1.reduce((acc, val) => {
        return acc + val;
    }, 0)

    var arry2 = this.state.FDList.map((listValue, index) => { return (listValue.depositAmount) });
    this.state.totalDepositAmount = arry2.reduce((acc, val) => {
        return acc + val;
    }, 0)

    this.state.balanceInterest = this.state.TotalInterestSum - this.state.paidInterest

    return (
        <>
            {this.ResponseLoadingModal()}

            {this.state.CheckFDInfo ?
                <FDDetails show={this.state.CheckFDInfo} onHide={() => this.setState({ CheckFDInfo: !this.state.CheckFDInfo })} />
                : null
            }
            {this.state.FDSummaryModal ?
                <FDSummaryPDF show={this.state.FDSummaryModal} onHide={() => this.setState({ FDSummaryModal: false })} />
                : null}
            {/* <Header fdonclick={() => this.setState({ FDWithdraw: false, FDLoansSection: false, })} /> */}
            <Container fluid>
                <Row>
                    <Col className='p-0'>
                    <section className='b-color mb-3'>
                        <Container>
                        <Row style={{paddingLeft:11}}>
                            <Col lg={4} className='rmv-pad text-color block' >
                                <Row className=''>
                                    <p className='t-left fontSize'>
                                        <h5> FIXED DEPOSITS </h5>
                                    </p>
                                </Row>
                                <Row className=''>
                                    <div className='t-left fontSize'>
                                        <Button
                                         onMouseOver={()=>this.setState({mouseOver1:1})}
                                         onMouseOut={()=>this.setState({mouseOver1:0})}
                                            onClick={() => this.setState({ FDWithdraw: true })}
                                            className="home-btn" variant="primary" type="submit">
                                            <div>
                                                <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===1?FDwithdrawn2:FDwithdrawn} />
                                                <p className='hbuttonfont'> WITHDRAWN DEPOSIT</p>
                                            </div>
                                        </Button>
                                        <Button
                                        onMouseOver={()=>this.setState({mouseOver1:2})}
                                        onMouseOut={()=>this.setState({mouseOver1:0})}
                                            onClick={() => this.setState({ FDLoansSection: true, FDWithdraw: false })}
                                            className="home-btn" variant="primary" type="submit">
                                            <div>
                                                <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===2?FDLoanImage2:FDLoanImage} />
                                                <p className='hbuttonfont'>FIXED DEPOSIT LOANS</p>
                                            </div>
                                        </Button>
                                        <Button
                                        onMouseOver={()=>this.setState({mouseOver1:3})}
                                        onMouseOut={()=>this.setState({mouseOver1:0})} 
                                        onClick={() => this.fdRates()} className="home-btn" variant="primary" type="submit">
                                            <div>
                                                <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===3?fdrates2:fdrates} />
                                                <p className='hbuttonfont'>CURRENT FIXED DEPOSIT RATES</p>
                                            </div>
                                        </Button>
                                        <Button
                                        onMouseOver={()=>this.setState({mouseOver1:4})}
                                        onMouseOut={()=>this.setState({mouseOver1:0})} 
                                        onClick={() => this.Opencal()} className="home-btn" variant="primary" >
                                            <div>
                                                <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===4?fdcal2:fdcal} />
                                                <p className='hbuttonfont'>FIXED DEPOSIT CALCULATOR</p>
                                            </div>
                                        </Button>
                                        <Button
                                        onMouseOver={()=>this.setState({mouseOver1:5})}
                                        onMouseOut={()=>this.setState({mouseOver1:0})}
                                         onClick={() => this.setState({ FDSummaryModal: true })} className="home-btn" variant="primary" >
                                            <div>
                                                <img className='hbuttonimage' alt="Senfin" src={this.state.mouseOver1===5?fdsmry2:fdsmry} />
                                                <p className='hbuttonfont'>FIXED DEPOSIT SUMMARY</p>
                                            </div>
                                        </Button>
                                    </div>
                                </Row>
                            </Col>

                            <Col lg={8} className=' text-color ' >
                                <Row className='block'>
                                    <p className='t-left fontSize'>
                                        <h5> </h5>
                                    </p>
                                </Row>
                                <Row className="">
                                    <Col lg={4} className='rmv-pad2' >
                                        <div className='d-box d-boxfd'>
                                            <p className='t-right fontSize'>
                                                Active Deposits<br />
                                                <h2>{this.state.FDList.length}</h2>
                                            </p>
                                        </div>
                                    </Col>
                                    <Col lg={4} className='rmv-pad2'>
                                        <div className='d-box d-boxfd'>
                                            <p className='t-right fontSize'>
                                                Total Deposit Value<br />
                                                <h2>{this.state.totalDepositAmount?parseFloat(this.state.totalDepositAmount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'):"0.00"}</h2>
                                                LKR
                                            </p>
                                        </div>
                                    </Col>
                                    <Col lg={4} className='rmv-pad2'>
                                        <div className='d-box d-boxfd margin-right'>
                                            <p className='t-right fontSize'>
                                                Total Interest<br />
                                                <h2>{this.state.TotalInterestSum?parseFloat(this.state.TotalInterestSum).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'):"0.00"}</h2>
                                                LKR
                                            </p>
                                        </div>
                                    </Col>
                                </Row>  
                                <Row className='block'>
                                    <p className='t-left fontSize'>
                                        <h5> </h5>
                                    </p>
                                </Row>                          
                            </Col>
                        </Row>
                        </Container>
                        </section>
                        <Container>
                        {this.state.FDWithdraw ?
                        < FDWithdrawnDeposit />
                        : this.state.FDLoansSection ?
                        <FDLaons />
                        :
                        
                        <Row lg={12}>
                            <Table className='block-top' hover responsive>
                                <thead >
                                    <tr className='tr'>
                                        <th className='td-width'>
                                            <div className="d-flex flex-row justify-content-center t-height">
                                                <p className="sav-tbl-head4"> Deposit Number </p>
                                                <div className='fd-tbl-head3'>
                                                    <div className="w3-button2 fd-uparw" onClick={()=>{
                                                        this.setState({fdSort:!this.state.fdSort})
                                                        this.sortDep()
                                                    }
                                                    }
                                                    >
                                                        <img className="fd-sort-btn" src={this.state.fdSort?uparrow: downarrow} />
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </th>
                                        <th className='td-width'>
                                            <div className="d-flex flex-row justify-content-center t-height">
                                                <p className="sav-tbl-head4 t-right">Capital LKR </p>
                                                <div className='fd-tbl-head3'>
                                                    <div className="w3-button2 fd-uparw" onClick={() =>
                                                    {
                                                        this.setState({fdSort1:!this.state.fdSort1})
                                                        this.sortDep1()
                                                    } 
                                                    }
                                                    >
                                                        <img className="fd-sort-btn" src={this.state.fdSort1?uparrow: downarrow} />
                                                    </div>
                                                   
                                                </div>
                                            </div>
                                        </th>
                                        <th className='td-width'>
                                            <div className="d-flex flex-row t-height">
                                                <p className="sav-tbl-head4">Interest Amount LKR </p>
                                                <div className='fd-tbl-head3'>
                                                    <div className="w3-button2 fd-uparw" onClick={()=>{
                                                        this.setState({fdSort2:!this.state.fdSort2})
                                                        this.sortDep2()
                                                    }
                                                    }
                                                    >
                                                        <img className="fd-sort-btn" src={this.state.fdSort2?uparrow: downarrow} />
                                                    </div>
                                                   
                                                </div>
                                            </div>
                                        </th>
                                        <th className='td-width'>
                                            <div className="d-flex flex-row justify-content-center t-height">
                                                <p className="sav-tbl-head4">Total LKR</p>
                                                <div className='fd-tbl-head3'>
                                                    <div className="w3-button2 fd-uparw" onClick={()=>{
                                                        this.setState({fdSort3:!this.state.fdSort3})
                                                        this.sortDep3()
                                                    }
                                                    }
                                                    >
                                                        <img className="fd-sort-btn" src={this.state.fdSort3?uparrow: downarrow} />
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </th>
                                        <th className='td-width'>
                                            <div className="d-flex flex-row justify-content-center t-height">
                                                <p className="sav-tbl-head4">Interest Paid LKR</p>
                                                <div className='fd-tbl-head3'>
                                                    <div className="w3-button2 fd-uparw" onClick={()=>{
                                                        this.setState({fdSort4:!this.state.fdSort4})
                                                        this.sortDep4()
                                                    }
                                                    }
                                                    >
                                                        <img className="fd-sort-btn" src={this.state.fdSort4?uparrow: downarrow} />
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </th>
                                        <th className='td-width '>
                                            <div className="d-flex flex-row justify-content-center t-height">
                                                <p className="sav-tbl-head4">Maturity Date</p>
                                                <div className='fd-tbl-head3'>
                                                    <div className="w3-button2 fd-uparw" onClick={()=>{
                                                        this.setState({fdSort5:!this.state.fdSort5})
                                                        this.sortDep5()
                                                    }
                                                    }
                                                    >
                                                        <img className="fd-sort-btn" src={this.state.fdSort5?uparrow: downarrow} />
                                                    </div>                                                    
                                                </div>
                                            </div>
                                        </th>
                                        <th className='td-width4'>                                           
                                        </th>
                                    </tr>
                                </thead>
                                <tbody >
                                    {this.state.FDList.map((listValue, index) => {
                                        return (
                                            <tr className='tr-h' >
                                                <td className='td-width'>
                                                    <p className='tb-text '>{listValue.fdNumber}</p>
                                                </td>
                                                <td className='td-width'>
                                                    <p className='tb-text '>{listValue.depositAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                </td>
                                                <td className='td-width'>
                                                    <p className='tb-text'>{listValue.totalInterestAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                </td>
                                                <td className='td-width'>
                                                    <p className='tb-text '>{(listValue.depositAmount + listValue.totalInterestAmount).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                </td>
                                                <td className='td-width'>
                                                    <p className='tb-text '>{listValue.paidAmount.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</p>
                                                </td>
                                                <td className='td-width'>
                                                    <p className='tb-text'>{moment(listValue.matirutyDate).format('DD/MM/YYYY')}</p>
                                                </td>
                                                <td className='td-width5'>
                                                    <Button onClick={() => this.FDMoreInfo(listValue)} className='btn-browse' variant="primary" type="submit">
                                                        Details
                                                    </Button>
                                                </td>
                                            </tr>
                                        )
                                    })
                                    }
                                </tbody>
                            </Table>
                        </Row>                        
                        }
                        </Container>
                    </Col>
                </Row> 
            </Container>
        </>
    );
}
}
export default FDHome;